import React, { useState } from 'react';
import ImageGrid from './ImageGrid';
import Lightbox from './Lightbox';
export function LightboxImageGrid(props) {
    const [openLightbox, setOpenLightbox] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);
    const handleImageGridClick = (index) => {
        if (props.onImageClick) {
            props.onImageClick(index);
        }
        else {
            setOpenLightbox(true);
            setImageIndex(index);
        }
    };
    const handleImageGridClose = () => setOpenLightbox(false);
    return React.createElement("div", null,
        React.createElement(ImageGrid, { images: props.images, cellHeight: props.imageGridCellHeight, spacing: props.imageGridSpacing, onClick: handleImageGridClick }),
        openLightbox &&
            React.createElement(Lightbox, { images: props.images, initialIndex: imageIndex, open: true, onClose: handleImageGridClose }));
}
